import React from 'react';
import { Link as Anchor } from "react-router-dom";
import { ChevronRight } from 'lucide-react';
import './BuscarCeroKm.css';

export default function BuscarCeroKm() {
    return (
        <section className='ido-cero-km-section'>
            {/* Trama binaria de fondo sutil (Pág 9 del manual) */}
            <div className="ido-binary-watermark">01010101010101010</div>

            <div className='ido-cero-km-container'>
                <div className='ido-cero-km-content'>
                    <span className="ido-pre-title">STOCK EXCLUSIVO</span>
                    <h2 className='ido-cero-km-title'>
                        INGENIERÍA <span className="text-red">JAPONESA.</span> <br />
                        PASIÓN EN CADA CURVA.
                    </h2>
                    <p className="ido-cero-km-p">
                        Descubrí la precisión de Subaru y la eficiencia de Suzuki.
                        Unidades 0km listas para entrega inmediata bajo el respaldo de Grupo Antún.
                    </p>

                    <Anchor to="/stock/autos" className='ido-btn-main'>
                        EXPLORAR MODELOS <ChevronRight size={20} />
                    </Anchor>
                </div>
            </div>

            {/* El detalle rojo lateral característico del manual */}
            <div className="ido-side-accent"></div>
        </section>
    );
}